import { shallowEqual } from "@knyt/artisan";
/**
 * Determines if two listener declarations are equal.
 *
 * @internal scope: package
 */
export function areListenersEqual(prevListener, nextListener) {
    if (prevListener === nextListener) {
        return true;
    }
    if (!prevListener || !nextListener) {
        return false;
    }
    if (prevListener.type === nextListener.type &&
        prevListener.handler === nextListener.handler &&
        shallowEqual(prevListener.options, nextListener.options)) {
        return true;
    }
    return false;
}
